/** 管理画面の起動口。 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import { App } from './App.js';
import { SessionProvider } from './auth/session.js';

const container = document.getElementById('root');
if (!container) {
  throw new Error('画面の置き場所が見つかりません');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
